"use client";

import { useState } from "react";
import Counter from "../components/Counter";

export default function HeroCounter() {
  return (
    <section id="hero-counter" className="bg-indigo-600 w-full py-8">
      <div className="w-full container mx-auto grid grid-cols-2 sm:grid-cols-4 gap-8 ">
        <div className="text-white flex flex-col items-center">
          <Counter target={50} />
          <p className="text-white">Clients</p>
        </div>
        <div className="text-white flex flex-col items-center">
          <Counter target={2500} />
          <p className="text-white">Transactions</p>
        </div>
        <div className="text-white flex flex-col items-center">
          <Counter target={25000} />
          <p className="text-white">Transactions</p>
        </div>
        <div className="text-white flex flex-col items-center">
          <Counter target={489} />
          <p className="text-white">Transactions</p>
        </div>
      </div>
    </section>
  );
}
